import React, { useState, useEffect } from 'react';
import SwpsNews from './EmailSignupForm';
import './styles.css';
import poolIllustration from './swps-illus.png';

const AppContainer = () => {
  const [site, setSite] = useState('');
  const [loading, setLoading] = useState(true);
  const [isConfirmationPage, setIsConfirmationPage] = useState(false);
  const [isDeclinePage, setIsDeclinePage] = useState(false);
  
  useEffect(() => {
    const hostname = window.location.hostname;
    const params = new URLSearchParams(window.location.search);
    const siteParam = params.get('site');
    
   
    const path = window.location.pathname;
    if (path.includes('subscription-confirmed')) {
      setIsConfirmationPage(true);
    } else if (path.includes('subscription-declined')) {
      setIsDeclinePage(true);
    }

    if (siteParam === 'aeroe' || siteParam === 'nockpool') {
      setSite(siteParam);
    } else if (hostname.includes('aeroe.io')) {
      setSite('aeroe');
    } else if (hostname.includes('nockpool.com')) {
      setSite('nockpool');
    } else {
      setSite('nockpool');
    }
    
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="loading-indicator">Loading...</div>;
  }

  const validSite = site && (site === 'aeroe' || site === 'nockpool') ? site : 'nockpool';
  const config = validSite === 'aeroe' ? {
    name: 'Aeroe', 
    formId: '1FAIpQLSd6oUw0uy7t86HzuAS3Y3-ASm7MrhjqVhlN7v5Ci8iSu6aKlA',
    emailFieldId: '482125494',
    verificationKey: '6LeOxTErAAAAAOCNiXWKqTA3cDAwd9WkBkNcxvm0',
    apiEndpoint: '/api/submit',
    primaryColor: '#ff3e31',
    secondaryColor: '#333333',
    bgClass: 'aeroe-background',
    logoUrl: '/aeroe-logo.png'
  } : {
    name: 'NockPool',
    formId: '1FAIpQLSfWsdx8m5Q-yPKDN1PoxdfM40cSM62sBUp3dbSmtfFkNcUTTA',
    emailFieldId: '282200660', 
    verificationKey: '6Lf8xTErAAAAAEu6fmI8Chg2zR4xESjMVLd-kRAZ',
    apiEndpoint: '/api/submit',
    primaryColor: '#e67e22', 
    secondaryColor: '#66D6DA',
    bgClass: 'nockpool-background',
    logoUrl: '/nockpool-logo.png'
  };

  const containerStyle = {
    '--theme-primary': config.primaryColor,
    '--theme-secondary': config.secondaryColor
  };

 
  const nockpoolStyle = validSite === 'nockpool' ? {
    '--bg-image': `url(${poolIllustration})`
  } : {};

  const renderAeroeHeading = () => {
    if (validSite !== 'aeroe') return null;
    
    return (
      <div className="aeroe-heading">
        <h1>One App. All of Nockchain.</h1>
        <p className="subtitle">Wallet suite and mining for Nockchain.</p>
        <div className="coming-soon-badge">Coming Soon</div>
      </div>
    );
  };
  
 
  const renderConfirmationMessage = () => {
    if (isConfirmationPage) {
      return (
        <div className="signup-section" style={containerStyle}>
          <div className="newsletter-component">
            <h1>Subscription Confirmed</h1>
            <div className="message-display success">
              <p>Thanks for subscribing! We'll be in touch with updates about {config.name}.</p>
            </div>
          </div>
        </div>
      );
    } else if (isDeclinePage) {
      return (
        <div className="signup-section" style={containerStyle}>
          <div className="newsletter-component">
            <h1>Subscription Declined</h1>
            <div className="message-display">
              <p>You've chosen not to receive updates about {config.name}. You can subscribe later if you change your mind.</p>
            </div>
          </div>
        </div>
      );
    }
    
    return null;
  };

  const renderFooter = () => {
      return (
        <footer className="page-footer">
          <p>Southwestern Pool Supply Co Inc. 𐚁 Austin, Texas</p>
          <p><a href="/privacy">Privacy Policy</a> || <a href="/terms">Terms of Service</a></p>
          <div className="social-links">
            <a href="https://x.com/swpsco" className="social-link">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24"><path fill="#333" d="M459.4 151.7c.3 4.5 .3 9.1 .3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.5 0-114.7-17.2-161.1-47.1 8.4 1 16.6 1.3 25.3 1.3 49.1 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.7-84.1-52-84.1-103v-1.3c14 7.8 30.2 12.7 47.4 13.3-28.3-18.8-46.8-51-46.8-87.4 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.3z"/></svg>
            </a>
            <a href="https://github.com/swpsco" className="social-link">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" width="24"><path fill="#333" d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"/></svg>
            </a>
            {/* <a href="https://discord.gg/WQd6Z3gFzY" className="social-link">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="28"><path fill="#333" d="M524.5 69.8a1.5 1.5 0 0 0 -.8-.7A485.1 485.1 0 0 0 404.1 32a1.8 1.8 0 0 0 -1.9 .9 337.5 337.5 0 0 0 -14.9 30.6 447.8 447.8 0 0 0 -134.4 0 309.5 309.5 0 0 0 -15.1-30.6 1.9 1.9 0 0 0 -1.9-.9A483.7 483.7 0 0 0 116.1 69.1a1.7 1.7 0 0 0 -.8 .7C39.1 183.7 18.2 294.7 28.4 404.4a2 2 0 0 0 .8 1.4A487.7 487.7 0 0 0 176 479.9a1.9 1.9 0 0 0 2.1-.7A348.2 348.2 0 0 0 208.1 430.4a1.9 1.9 0 0 0 -1-2.6 321.2 321.2 0 0 1 -45.9-21.9 1.9 1.9 0 0 1 -.2-3.1c3.1-2.3 6.2-4.7 9.1-7.1a1.8 1.8 0 0 1 1.9-.3c96.2 43.9 200.4 43.9 295.5 0a1.8 1.8 0 0 1 1.9 .2c2.9 2.4 6 4.9 9.1 7.2a1.9 1.9 0 0 1 -.2 3.1 301.4 301.4 0 0 1 -45.9 21.8 1.9 1.9 0 0 0 -1 2.6 391.1 391.1 0 0 0 30 48.8 1.9 1.9 0 0 0 2.1 .7A486 486 0 0 0 610.7 405.7a1.9 1.9 0 0 0 .8-1.4C623.7 277.6 590.9 167.5 524.5 69.8zM222.5 337.6c-29 0-52.8-26.6-52.8-59.2S193.1 219.1 222.5 219.1c29.7 0 53.3 26.8 52.8 59.2C275.3 311 251.9 337.6 222.5 337.6zm195.4 0c-29 0-52.8-26.6-52.8-59.2S388.4 219.1 417.9 219.1c29.7 0 53.3 26.8 52.8 59.2C470.7 311 447.5 337.6 417.9 337.6z"/></svg>
            </a> */}
          </div>
        </footer>
      );
  };

  return (
    <div className={`main-container ${config.bgClass}`} style={nockpoolStyle}>
      <div className="content-wrapper">
        <header className="page-header">
          <div className="logo-wrapper">
            <img src={config.logoUrl} alt={`${config.name} Logo`} className="site-logo" />
          </div>
        </header>
        
        <main className="main-content">
          {renderAeroeHeading()}
          
          {/* Show either confirmation message or signup form */}
          {(isConfirmationPage || isDeclinePage) ? (
            renderConfirmationMessage()
          ) : (
            <div className="signup-section" style={containerStyle}>
              <SwpsNews 
                formId={config.formId}
                emailFieldId={config.emailFieldId}
                verificationKey={config.verificationKey}
                apiEndpoint={config.apiEndpoint}
                siteName={config.name}
                site={validSite}
              />
            </div>
          )}
        </main>
        
        {renderFooter()}
      </div>
    </div>
  );
};

export default AppContainer;